module.exports = __webpack_public_path__ + "img/character.f8646e5c.png";